import { Component, OnInit, Input } from '@angular/core';
import { IReportItemComponent } from "../models/i-report-item-component";
import { AssessmentResult } from "../../shared/models/assessment-result";
import { Variable } from "../models/variable";
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';

@Component({
  selector: 'app-text-item',
  templateUrl: './text-item.component.html'
})
export class TextItemComponent extends BaseReportItemComponent implements OnInit, IReportItemComponent {

  private data:any;

  constructor() {
    super();
   }

  ngOnInit() {
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    this.data = data;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/text-item/text-item.component.ts